import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { scChatbotAnimation } from '../animations';


@Component({
    selector: 'sc-chatbot-answer',
    templateUrl: './answer.component.html',
    styleUrls: ['./answer.component.scss'],
    animations: [scChatbotAnimation.message],
    standalone: false
})
export class ScChatbotAnswerComponent implements OnInit {

  @Input()
  message : any;

  @Input() 
  avatar : string;

  @Input()
  isOwnMessage = false;

  @Output()
  sendMessage = new EventEmitter<any>();

  @Input()
  canQuickReply = false;

  @Output()
  onQuickReply = new EventEmitter<any>();

  public _visible;
  
  constructor() { }
  
  ngOnInit() {
    this._visible = this.message?.History ? 'visible-instant' : 'visible';
  }

  getMessageJson() {
    return JSON.stringify(this.message);
  }

  resendMessage()
  {
    this.sendMessage.next(this.message);
  }

  sendQuickReply(quickReply)
  {
    var index = this.message.Payload.QuickReplies.indexOf(quickReply);

    var args = {

      Payload: {
        Body: quickReply.Label,
        IsQuickReply: true,
        QuickReplyId: quickReply.Id,
        QuickReplyIndex: index
      }

    }

    this.onQuickReply.next(args);
  }

}
